// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.75.2/styles/" + "videojs" + ".chunk.css?" + "41a376f288109fbb5dfb" + "";
};